import { Container, IDestroyOptions, TextStyle } from "pixi.js";
import { TextWithUnderline } from "../../../game/components/TextWithUnderline";
import { GameFont } from "../../../common/GameFont";
import { Event } from "event-system";

export class MyWalletInfoTextComponent extends Container {
    public readonly onContactClick: Event<void>;

    private static readonly TEXT = 'HOW CAN I EXPORT MY IN-GAME PRIVATE KEY?';

    private contactText: TextWithUnderline;

    public constructor() {
        super();
        this.onContactClick = new Event();
        this.contactText = new TextWithUnderline(MyWalletInfoTextComponent.TEXT, new ComponentTextStyle(), 0, -5, 3);
        this.contactText.eventMode = "static";
        this.contactText.on('pointerup', this.onContactClickHandle, this);
        this.addChild(this.contactText);
    }

    private onContactClickHandle(): void {
        this.onContactClick.emit();
    }

    public override destroy(options?: boolean | IDestroyOptions): void {
        this.contactText.off('pointerup', this.onContactClickHandle, this);
        super.destroy(options);
    }
}

class ComponentTextStyle extends TextStyle {
    public constructor() {
        super({
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 36,
            fill: "78BEFF"
        });
    }
}
